import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output, ViewChild} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import {DocumentService, Image, PageService} from '../../common/services';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '../../../common/widgets/general/data-table';
import {MatDataSourceGeneric} from '@Services/base/daoService';

import {Document} from '../../common/services';
import {FileSizePipe} from '@Common/widgets/pipes/file-size';
import {DialogData, DialogValidationComponent} from '../../../common/widgets/general/dialog-validation';


import {PageListModalComponent} from '../pages/page-list-modal/page-list-modal.component';

import {DocumentAddModaleComponent} from './document-add-modale/document-add-modale.component';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'p8-bdc-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
  @Input() selectingMode = false;

  @Output() documentSelected = new EventEmitter<Document>();

  dsDocuments: MatDataSourceGeneric<Document> = new MatDataSourceGeneric<Document>();
  @ViewChild(DataTableComponent, { static: true }) dataTable: DataTableComponent;

  extraParams: Map<string, string> = new Map<string, string>();

  columns: ColumnDataTable[] = [
    { columnDef: 'title', header: 'Titre', display: (doc: Document) => {
        return doc.title;
      } , sort: true, hidden: false, truncate: true },
    { columnDef: 'filename', header: 'Nom du fichier', display: (doc: Document) => {
        return doc.filename;
      } , sort: false, hidden: false, truncate: true, flex: 20 },

    { columnDef: 'dt_updated', header: 'Modification', display: (doc: Document) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return dp.transform(`${doc.dt_updated}`, 'dd/MM/yyyy H:mm');
      } , sort: true, hidden: false, flex: 13 },

    { columnDef: 'size', header: 'Taille', display: (image: Image) => {
        const fs = new FileSizePipe(this.locale);
        return fs.transform(image.size, 2, this.locale);
      } , sort: false, hidden: false, flex: 10 },
    { columnDef: 'nb_pages', header: 'Pages', display: (doc: Document) => {
         return doc.nb_pages;
      } , sort: false, hidden: false, flex: 5 },
  ];

  actions: ActionDataTable[] = [
    { label: 'Sélectionner', tooltip: 'Sélectionner le document pour l\'ajouter à la page',  icon: 'add_circle_outline',
      click: (doc: Document) => this.selection(doc),
      hidden: row => ! this.selectingMode},

    { label: 'Pages', tooltip: 'Voir la liste des pages associées',  icon: 'pageview',
      click: (doc: Document) => this.listePages(doc),
      hidden: (row: Document) => {
        return this.selectingMode || row.nb_pages === 0;
      }},

    { label: 'Modifier', tooltip: 'Modifier les informations du document',  icon: 'edit',
      click: (doc: Document) => this.modifier(doc),
      hidden: (row: Document) => {
        return this.selectingMode;
      } },

    { label: 'Supprimer', tooltip: 'Supprimer le document de la bibliothèque',  icon: 'delete',
      click: (doc: Document) => this.supprimer(doc),
      hidden: (row: Document) => {
        return this.selectingMode || row.nb_pages > 0;
      } },
    { label: 'Télécharger', tooltip: 'Télécharger le document',  icon: 'file_download',
      click: (doc: Document) => this.download(doc),
      hidden: row => this.selectingMode},
  ];

  maxItems = 10;

  constructor(@Inject(LOCALE_ID) private locale: string,
              private documentService: DocumentService,
              private pagesSvc: PageService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private dialog: MatDialog
  ) {
    this.dsDocuments.daoService = this.documentService;
  }

  ngOnInit() {
    if (this.selectingMode) {
      this.maxItems = 5;
    }
  }

  modifier(doc: Document) {
    this.router.navigate([doc.id, 'edit'], {relativeTo: this.activatedRoute});
  }

  listePages(doc: Document) {
    const by_doc: Map<string, string> = new Map<string, string>();

    by_doc.set('by_document', doc.id.toString());
    this.pagesSvc.listAll(by_doc).subscribe((pages) => {
      const modalPages = this.dialog.open(PageListModalComponent, { data: pages });
      modalPages.updatePosition({top: '100px'});
    });
  }

  selection(doc: Document) {
    this.documentSelected.emit(doc);
  }

  download(doc: Document) {
    this.documentService.download(doc);
  }

  supprimer(doc: Document) {
    const data = new DialogData();
    data.title = 'Supprimer document';
    data.message = `Souhaitez-vous supprimer le document (${doc.title}) de la bibliothèque ?`;
    data.buttonTextTrue = 'SUPPRIMER DOCUMENT';
    data.buttonTextFalse = 'ANNULER';

    const modalConfirm = this.dialog.open(DialogValidationComponent, { data: data, disableClose: true});
    modalConfirm.updatePosition({top: '100px'});
    modalConfirm.afterClosed().subscribe(confirm => {
      if (confirm === true) {
        this.documentService.delete(doc).subscribe(() => {
          this.dataTable.reload();
        });
      }
    });
  }

  openAddModaleDocument() {
    const modal = this.dialog.open(DocumentAddModaleComponent, );
    modal.updatePosition({top: '50px'});
    modal.updateSize('1200px');

    modal.afterClosed().subscribe((added: boolean) => {
      if (added) {
        this.dataTable.reload();
      }
    });
  }
}
